/**
 * Office entity index page
 */

import { EntityIndex } from './base';
import { canonicalPath } from '@electinfo/common';
import type { EntityConfig, EntitySearchResult } from './types';

class OfficeIndex extends EntityIndex {
  getConfig(): EntityConfig {
    return {
      entityType: 'Office',
      placeholder: 'Search offices...',
      browseTitle: 'All Offices',
      sortOrder: 'ASC',
      tabs: [
        { id: 'all', label: 'All Offices', filter: null },
        { id: 'national', label: 'National', filter: 'office_type:P' },
        { id: 'statewide', label: 'State-wide', filter: 'office_type:S' },
        { id: 'district', label: 'District', filter: 'office_type:H' }
      ],
      formatResult: (result: EntitySearchResult) => {
        const officeType = result.office || '';
        const state = result.state || '';
        const typeNames: Record<string, string> = { 'P': 'President', 'S': 'Senate', 'H': 'House' };
        const typeName = typeNames[officeType] || 'Office';

        return {
          url: `/${canonicalPath('Office', result.id)}/`,
          name: result.name || '',
          meta: state ? `${typeName} - ${state}` : typeName
        };
      }
    };
  }
}

new OfficeIndex();
